import { render } from "./DemoModal.vue?vue&type=template&id=2f71e17e&scoped=true"
import script from "./DemoModal.vue?vue&type=script&lang=js"
export * from "./DemoModal.vue?vue&type=script&lang=js"

import "./DemoModal.vue?vue&type=style&index=0&id=2f71e17e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f71e17e"]])

export default __exports__